let appConfig = {
  passportUrl: [
    'http://passport.mifengdao.com'
  ],
  baseUrl: [
    'http://api.course.t.mifengdao.com'
  ],
  sso_token: [
    'develop'
  ]
}
let url = window.location.href;
let localhost = 'localhost';
let develop = '.d.';
let test = '.t.';
let preview = '.p.';
console.log('url', url);
var host = 'mifengdao' ;
if (url.indexOf('kuaijichong') != -1) {
  host = 'kuaijichong' ;
}else{
  host = 'mifengdao' ;
}

//环境判断
if (url.indexOf(develop) != -1) {
  console.log('开发环境 develop', (url.indexOf(develop) != -1));
  appConfig.classUrl = 'http://class.d.'+host+'.com';
  appConfig.ShoppUrl = 'http://www.d.'+host+'.com/';
  appConfig.passportUrl = 'http://passport.d.'+host+'.com';
  appConfig.baseUrl = 'http://api.course.d.mifengdao.com';
  appConfig.shicaoUrl = 'http://shicao.d.'+host+'.com';
  appConfig.sso_token = 'sso_token_develop';
}
else if (url.indexOf(test) != -1) {
  console.log('测试环境test');
  appConfig.classUrl = 'http://class.t.'+host+'.com';
  appConfig.ShoppUrl = 'http://www.t.'+host+'.com/';
  appConfig.passportUrl = 'http://passport.t.'+host+'.com';
  appConfig.baseUrl = 'http://api.course.t.mifengdao.com';
  appConfig.shicaoUrl = 'http://shicao.t.'+host+'.com';
  appConfig.sso_token = 'sso_token_test';

}
else if (url.indexOf(preview) != -1) {
  console.log('预正式环境preview');
  appConfig.classUrl = 'http://class.p.'+host+'.com';
  appConfig.ShoppUrl = 'https://www.'+host+'.com/';
  appConfig.passportUrl = 'https://passport.'+host+'.com';
  appConfig.baseUrl = 'http://api.course.p.mifengdao.com';
  appConfig.shicaoUrl = 'http://shicao.p.'+host+'.com';
  appConfig.sso_token = 'sso_token_broker';
}
else if (url.indexOf(localhost) != -1) {
  console.log('开发环境 develop');
  appConfig.classUrl = 'http://class.t.'+host+'.com';
  appConfig.ShoppUrl = 'http://www.t.'+host+'.com/';
  appConfig.passportUrl = 'http://passport.t.'+host+'.com';
  appConfig.baseUrl = 'http://api.course.t.mifengdao.com';
  appConfig.shicaoUrl = 'http://shicao.t.'+host+'.com';
  appConfig.sso_token = 'sso_token_test';
}
else {
  appConfig.classUrl = 'https://class.'+host+'.com';
  appConfig.ShoppUrl = 'https://www.'+host+'.com/';
  appConfig.passportUrl = 'https://passport.'+host+'.com';
  appConfig.baseUrl = 'https://api.course.mifengdao.com';
  appConfig.shicaoUrl = 'https://shicao.'+host+'.com';
  appConfig.sso_token = 'sso_token_broker';
}

appConfig.development_token = '4r9j6jxvpaucwswokgwsoks84';

export default appConfig
